import { render, staticRenderFns } from "./PixForm.vue?vue&type=template&id=56962e29"
import script from "./PixForm.vue?vue&type=script&lang=js"
export * from "./PixForm.vue?vue&type=script&lang=js"
import style0 from "./PixForm.vue?vue&type=style&index=0&id=56962e29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports